import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StatementTable, HistoryTable, WalletTable, EarningsTable } from "./";
import Tabs from "react-responsive-tabs";
import style from "./ilifepoint.module.scss";
import { propTypes } from "react-bootstrap/esm/Image";
import { useSelector } from "react-redux";
import HistorysTable from "./HistorysTable";

const stylees = {
  paddingTop: "10px",
  fontFamily: "system-ui",
};

function Content({
  tableData,
  changeHandler,
  paginationHandler,
  repurchase_status,
  exportData,
  loader,
  selectedTab,
  epointsTransactionsHistory,
  epointsEarned,
}) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const [tabs, setTabs] = useState([]);
  console.log(tableData, "table data for lifestyle points");
  useEffect(() => {
    const newTabs = [];
    if (epointsTransactionsHistory) {
      newTabs.push("ilifehistory");
    }
    if (epointsEarned) {
      newTabs.push("ilifeearning");
    }
    setTabs(newTabs);
  }, [epointsTransactionsHistory, epointsEarned]);

  const getTabs = () => {
    return tabs.map((tab, index) => ({
      title: t("Common." + tab),
      getContent: () => getContent(tab),
      key: tab,
      tabClassName: style.TabClass,
      panelClassName: style.TabPanel,
    }));
  };

  //get content
  const getContent = (contentId) => {
    if (contentId === "ilifeearning") {
      return (
        <div className={style.dataTable} style={stylees}>
          <EarningsTable
            loader={loader}
            ContentData={tableData.earnings}
            paginationchange={paginationHandler.earnings}
            exportData={exportData}
            selectedTab={selectedTab}
          />
        </div>
      );
    } else if (contentId === "ilifehistory") {
      return (
        <div className={style.dataTable} style={stylees}>
          <HistorysTable
            loader={loader}
            ContentData={tableData.statement}
            paginationchange={paginationHandler.statement}
            exportData={exportData}
            selectedTab={selectedTab}
          />
        </div>
      );
    }
  };
  return (
    <div className={style.summary}>
      <div
        className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_tabContent}`
            : `${style.tabContent}`
        }`}
      >
        <Tabs
          items={getTabs()}
          transform={true}
          transformWidth={734}
          onChange={changeHandler}
          selectedTabKey="ilifeearning"
        />
      </div>
    </div>
  );
}

export default Content;
